import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export default class SMSNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Send SMS';
        this.id = 'node_sms_send';
        this.icon = 'HiCommandLine';
        this.linkedFeature = 'cell';
        this.icon = 'FaEnvelope';


        const settings: Setting[] = [
            {
                id: 'NUMBER',
                name: 'Phone Number',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                min: 1,
                default: '',
            },
            {
                id: 'DATA',
                name: 'Data',
                settingType: SettingType.STRINGVARIABLE,
                max: 160,
                required: true,
                default: '',
            },
        ];

        this.inputs = [
            {
                name: 'Send Data',
                portId: 'data_send',
                params: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const NUMBER = this.getSettingValue('NUMBER');
            const DATA = this.getSettingValue('DATA');
            if (NUMBER) {
                return `Send to "${NUMBER}" data "${DATA}"`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getDefines(): Array<Define> {
        return [
            {
                name: 'CELL__AT_USERMODE_ISENABLED',
                value: '1',
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const NUMBER = this.getSettingValue('NUMBER');
        const DATA = this.getSettingValue('DATA');

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            id: 'declare_cell_sms_send',
            template: `
declare sub cell_sms_send(byref phonenum as string, byref data as string)
`,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            id: 'cell_sms_enabled',
            template: `
cell_sms_enabled = true
`,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.CODE,
            id: 'sub_cell_sms_send',
            template: `
sub cell_sms_send(byref phonenum as string, byref data as string)
    'const SMS_CSMP_FO = "17" 'First Octet set to 17=SMS-SUBMIT
    'const SMS_CSMP_VP = "167" 'Validy Period set to 167, because FO=17
    'const SMS_CSMP_PID = "2" 'Protocol Identifier
    'const SMS_CSMP_DCS = "0" 'Data Coding Scheme

    'Execute subroutine for SENDING SMS-message
    'cell__at_usermode_sms_send(phonenum, data, SMS_CSMP_FO, SMS_CSMP_VP, SMS_CSMP_PID, SMS_CSMP_DCS)
    cell_send_sms(phonenum, data)
end sub`,
        });

        const links = project.getNodeLinks(this, 'data_send');
        if (links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                const link = links[i];
                const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
                const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
                const doneLinks = project.getNodeLinks(this, 'done');
                const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';

                blocks.push({
                    location: link.getSourceId(),
                    id: link.getID(),
                    blockType: BlockType.CODE,
                    template: `
        cell_sms_send(${this.project.parseCodeExpression(NUMBER, sourceParams, TibboDataType.STRING)},${this.project.parseCodeExpression(DATA, sourceParams, TibboDataType.STRING)})
        ${doneBlock}
        `,
                });
            }
        }
        return blocks;
    }

    getDetails(): string {
        return `
`;
    }
}
